const jwtDecode = require('jwt-decode');
const Session = require('./session');

function getTokenPayload() {
    var token = Session.getSessionAccessToken();
    if (token) {
        return jwtDecode(token);
    } else {
        return undefined;
    }
}

function getCurrentUserId() {
    var tokenData = getTokenPayload();
    if (tokenData) {
        return tokenData.User.Id;
    } else {
        return undefined;
    }
}

function getCurrentUserLogin() {
    var tokenData = getTokenPayload();
    if (tokenData) {
        return tokenData.User.Login;
    } else {
        return undefined;
    }
}

function getRoles() {
    var tokenData = getTokenPayload();
    if (tokenData) {
        return tokenData.User.Roles;
    } else {
        return undefined;
    }
}

function getCurrentUserCompanyId() {
    var tokenData = getTokenPayload();
    if (tokenData) {
        return tokenData.User.CompanyId;
    } else {
        return undefined;
    }
}

function getCurrentUserSubCompanyId() {
    var tokenData = getTokenPayload();
    if (tokenData) {
        return tokenData.User.SubCompanyId;
    } else {
        return undefined;
    }
}

function getUserData() {
    const tokenData = getTokenPayload();
    if (tokenData) {
        return (tokenData.User || {});
    } else {
        return {};
    }
}

module.exports = {
    getCurrentUserId: getCurrentUserId,
    getCurrentUserLogin: getCurrentUserLogin,
    getRoles: getRoles,
    getCurrentUserCompanyId: getCurrentUserCompanyId,
    getCurrentUserSubCompanyId: getCurrentUserSubCompanyId,
    getUserData: getUserData,
};


// WEBPACK FOOTER //
// ./App/services/userRights.js